import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    // Initialize from sessionStorage
    return sessionStorage.getItem("preferredLanguage") || "en";
  });

  const updateCurrentLang = (currentLanguage) => {
    sessionStorage.setItem("preferredLanguage", currentLanguage); // Sync with sessionStorage
    setCurrentLang(currentLanguage); // Update state
  };

  useEffect(() => {
    // Ensure state sync only on mount
    const storedCurrentLanguage = sessionStorage.getItem("preferredLanguage");
    if (storedCurrentLanguage && storedCurrentLanguage !== currentLang) {
      setCurrentLang(storedCurrentLanguage);
    }
    // No dependencies to prevent unnecessary re-renders
  }, [currentLang]); // Run only once on mount

  return (
    <AuthContext.Provider value={{ currentLang, updateCurrentLang }}>
      {children ? children : ''}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
